const faSpinnerThird = {
  prefix: 'fal',
  iconName: 'spinner-third',
  icon: [
    512,
    512,
    [],
    'f3f4',
    'M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1 17.1-34.3 26.7-73 26.7-113.9 0-136-106.1-247.2-240-255.5-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6c116.2 8.2 208 105.1 208 223.4 0 35.1-8.1 68.3-22.5 97.9-3.9 8-1.3 17.7 6.4 22.2z',
  ],
};
export default faSpinnerThird;
